export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            position: 'relative',
            zIndex: '0',
            isolation: 'isolate'
        },
        controls: {
            position: 'absolute',
            zIndex: '1',
            right: { base: '16px', lg: '24px' },
            top: { base: '68px', lg: '64px' },
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        control: {
            width: { base: '40px', lg: '32px' },
            height: { base: '40px', lg: '32px' }
        }
    })
}
